<template>
  <div
    :class="classes.adSliderWrapper"
    @mouseover="mouseOver(true)"
    @mouseleave="mouseOver(false)"
  >
    <transition
      name="slide-left"
      :class="[classes.slide]"
      v-show="showPreroll && usePreroll"
    >
      <slot name="preroll" />
    </transition>
    <transition
      name="slide-left"
      :class="[classes.slide]"
      v-visible="!showPreroll || !usePreroll"
    >
      <slot name="adcontent" />
    </transition>
  </div>
</template>
<script lang="ts">
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { defineComponent, watch, onMounted, ref, computed } from "vue";
import { injectPreview } from "@fresh8/ad-data-composition/src/preview";
import { injectPreroll } from "../hooks/usePreroll";

const { useStyles } = createUseStyles({
  adSliderWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    overflow: "hidden"
  },
  slide: {
    position: "absolute",
    transition: "all 0.5s ease",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: 1,
    "&.slide-left-enter-from": {
      transition: "none",
      transform: "translateX(-100%)"
    },
    "&.slide-left-leave-to": {
      transform: "translateX(100%)"
    }
  }
});

export default defineComponent({
  setup() {
    const showPreroll = ref(true);
    const { usePreroll } = injectPreroll();
    const previewContext = injectPreview();
    const timeout = ref<ReturnType<typeof setTimeout> | undefined>();

    const previewPreroll = computed(
      () => previewContext.preview.value.previewPreroll
    );

    const handleTimeout = cancel => {
      if (cancel && timeout.value !== undefined) {
        clearTimeout(timeout.value);
        timeout.value = undefined;
      } else {
        timeout.value = setTimeout(() => {
          if (!previewPreroll.value) {
            showPreroll.value = false;
          }
        }, 3000);
      }
    };

    watch(previewPreroll, newVal => {
      showPreroll.value = newVal;
    });

    // This will only update via the previews,
    // we only want to showPreroll for the preroll specific preview.
    watch(usePreroll, newVal => {
      if (previewPreroll.value) {
        showPreroll.value = newVal;
      }
    });

    const mouseOver = bool => {
      handleTimeout(bool);
    };

    onMounted(() => {
      handleTimeout(false);
    });

    const { classesRef } = useStyles(ref({}));
    return {
      mouseOver,
      classes: classesRef,
      showPreroll,
      usePreroll
    };
  }
});
</script>
